import { el } from "@dhx/ts-common/dom";
import locale from "../locales/en";

export const meta = {
	arrangeGroup: {
		id: "arrangeGroup",
		type: "inputsGroup",
		label: locale.arrange,
		validate: "number",
		options: [
			{ id: "x", value: "1000", label: "x", validate: "number" },
			{ id: "y", value: "999", label: "y", validate: "number" },
			{ id: "width", value: "1000", label: "w", validate: "number" },
			{ id: "height", value: "999", label: "h", validate: "number" },
		],
	},
	fillGroup: {
		id: "fillGroup",
		type: "color",
		label: locale.fill,
	},
	strokeGroup: {
		id: "strokeGroup",
		type: "strokeGroup",
		label: locale.stroke,
	},
	headerText: {
		id: "headerText",
		type: "textarea",
		label: locale.headerText,
	},
	headerFill: {
		id: "headerFill",
		type: "color",
		label: locale.headerFill,
	},
	headerStyle: {
		id: "headerStyle",
		type: "textProps",
		label: locale.headerStyle,
	},
	headerPosition: {
		id: "headerPosition",
		type: "headerPosition",
		label: locale.headerPosition,
	},
	headerEnable: {
		id: "headerEnable",
		type: "enable",
		label: locale.headerEnable,
	},
	subHeaderRowsEnable: {
		id: "subHeaderRowsEnable",
		type: "enable",
		lable: locale.subHeaderRowsEnable,
	},
	subHeaderColsEnable: {
		id: "subHeaderColsEnable",
		type: "enable",
		lable: locale.subHeaderColsEnable,
	},
	grid: {
		id: "gridStep",
		type: "inputsGroup",
		label: locale.gridStep,
		validate: "number",
		options: [{ id: "step", value: 0, icon: () => el(".dxi.dxi-grid-step"), validate: "number" }],
	},
	textPosition: {
		id: "textPosition",
		type: "inputsGroup",
		label: locale.textPosition,
		validate: "number",
		options: [
			{ id: "x", value: "1000", label: "x", validate: "number" },
			{ id: "y", value: "999", label: "y", validate: "number" },
		],
	},
	arrange: {
		id: "arrange",
		type: "inputsGroup",
		label: locale.arrange,
		validate: "number",
		options: [
			{ id: "x", value: "1000", label: "x", validate: "number" },
			{ id: "y", value: "999", label: "y", validate: "number" },
			{ id: "width", value: "1000", label: "w", validate: "number" },
			{ id: "height", value: "999", label: "h", validate: "number" },
			{
				id: "angle",
				value: "999",
				label: "y",
				validate: "number",
				icon: () => el(".dxi.dxi-rotate-right.rotate_icon"),
			},
		],
	},
	position: {
		id: "position",
		type: "inputsGroup",
		label: locale.position,
		validate: "number",
		options: [
			{ id: "dx", value: "1000", label: "dx", validate: "number" },
			{ id: "dy", value: "999", label: "dy", validate: "number" },
		],
	},
	size: {
		id: "size",
		type: "inputsGroup",
		label: locale.size,
		options: [
			{ id: "width", value: "1000", label: "w", validate: "number" },
			{ id: "height", value: "999", label: "h", validate: "number" },
		],
	},
	color: {
		id: "headerColor",
		type: "color",
		label: locale.color,
	},
	title: {
		id: "title",
		type: "textarea",
		label: locale.title,
	},
	text: {
		id: "text",
		type: "textarea",
		label: locale.text,
	},
	img: {
		id: "img",
		type: "image",
		label: locale.image,
	},
	fill: {
		id: "fill",
		type: "color",
		label: locale.fill,
	},
	textProps: {
		id: "textProps",
		type: "textProps",
		label: locale.textProps,
	},
	strokeProps: {
		id: "strokeProps",
		type: "stroke",
		label: locale.stroke,
	},
};

export function getMeta(properties): any[] {
	return properties.map(({ type, label, property }) => {
		return {
			...meta[type],
			id: property || meta[type].id,
			label: label || meta[type].label,
		};
	});
}
